import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    loadUser: (data) => request(ServicesEnum.passport, '/user/', 'get', data),
    acceptUserDocs: () => request(ServicesEnum.passport, '/documents/acceptance/', 'post', null),
    logout: (data) => request(ServicesEnum.passport, '/logout/', 'post', data),
    refreshToken: (data) => request(ServicesEnum.passport, '/token/refresh/', 'post', data),
    check2FA: (data) => request(ServicesEnum.passport, '/otp/user/', 'get', data),
    getState2FA: (data) => request(ServicesEnum.passport, '/user/two_factor/', 'get', data),
    getKycUserData: (data) => request(ServicesEnum.passport, '/kyc/profile/', 'get', data)
};
